import React from 'react';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import {DropzoneArea} from 'material-ui-dropzone';

import MediaOrderImportProgress from './MediaOrderImportProgress';
import {
    OnModalTrigger,
    HandleFileSubmit,
} from '../MediaOrdersTypes';
import './MediaOrderImport.scss';

interface MediaImportComponentProviderProps {
    isLoading: boolean;
    handleClose: OnModalTrigger;
    handleSubmit: HandleFileSubmit;
}

export default function MediaImportComponentProvider(props: MediaImportComponentProviderProps) {
    const {
        isLoading,
        handleClose,
        handleSubmit,
    } = props;
    
    const acceptedFiles = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/csv',
    ];
    
    if (isLoading)
        return <MediaOrderImportProgress handleClose={handleClose} />;
    
    return (
        <Container>
            <DropzoneArea
                dropzoneText="Upload a spreadsheet"
                acceptedFiles={acceptedFiles}
                onChange={handleSubmit}
                dropzoneParagraphClass="media-order-import__dropzone-title"
                filesLimit={1}
                showAlerts={false}
            />
            <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
            >
                <Button
                    variant="contained"
                    className="media-order-import__dropzone-btn"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
            </Grid>
        </Container>
    );
}
